import { Dropdown } from 'antd'
import { Main } from 'components/ActionStyles/ActionStyles'
import CustomTag from 'components/CustomTag/Custom'
import DefaultDropIcon from 'components/icons/DefaultDropIcon'
import moment from 'moment'
import React from 'react'
import { OuterDiv, StyledDivView, SubFLex, SubTitleText } from './style'

const ActionDropdown = ({
  veiwButton = false,
  jobId,
  data,
  onEditClick,
  onActionsClick,
  onViewClick,
}) => {
  const formatWithSup = date => {
    return moment(date)
      .format('Do MMMM YYYY')
      .replace(/(\d+)(st|nd|rd|th)/g, '$1<sup>$2</sup>')
  }

  const menu = (
    <OuterDiv>
      {data?.panelDetailsByDate?.map((value, index) => {
        return (
          <>
            <SubTitleText>
              {' '}
              <span
                dangerouslySetInnerHTML={{ __html: formatWithSup(value?.date) }}
              />
            </SubTitleText>

            <SubFLex centerVertically gap="5px" marginBottom="10px" wrap>
              {value?.panelDetails?.map((data, index1) => (
                <CustomTag
                  message={`${data?.startAMPMTime} - ${data?.endAMPMTime}`}
                  bordered={true}
                  background={'#F2F3F5'}
                  border={'#CCCFD6'}
                  textColor={'yellow'}
                  key={'tag' + index1}
                />
              ))}
            </SubFLex>
          </>
        )
      })}
    </OuterDiv>
  )

  return (
    <Main id="view_dropdown">
      <Dropdown
        overlay={menu}
        trigger={['click']}
        getPopupContainer={() => document.getElementById('view_dropdown')}
      >
        <StyledDivView onClick={e => e.preventDefault()}>
          View Schedule{' '}
          <span>
            <DefaultDropIcon />
          </span>
        </StyledDivView>
      </Dropdown>
    </Main>
  )
}

export default ActionDropdown
